import { render, staticRenderFns } from "./AppAudio.vue?vue&type=template&id=ded13432&scoped=true&"
import script from "./AppAudio.vue?vue&type=script&lang=js&"
export * from "./AppAudio.vue?vue&type=script&lang=js&"
import style0 from "./AppAudio.vue?vue&type=style&index=0&id=ded13432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded13432",
  null
  
)

export default component.exports